const listeners = new Set<() => void>();

/**
 * Framework-agnostic signal for "the session has ended".
 *
 * This event can be triggered in three ways:
 *   1. Logging out (the `onSettled` hook in `useLogout.tsx`)
 *   2. Initial load with dead or missing cookie in a protected route (the authenticated `loader` in `router.tsx`)
 *   3. Receiving a 401 response (thrown by the `onError` hooks in `queryClient.ts`)
 *
 * The `SessionWatcher` subscribes to this event and redirects the user to the login page.
 */
export const sessionEnded = {
  subscribe: (listener: () => void): (() => void) => {
    listeners.add(listener);

    return () => {
      listeners.delete(listener);
    };
  },

  notify: ({ otherTabsOnly } = { otherTabsOnly: false }): void => {
    if (!otherTabsOnly) listeners.forEach((listener) => listener());

    channel.postMessage(null);
  },
};

// Cross-tab notifications of the sessionEnded event
const channel = new BroadcastChannel('craft-session');
channel.onmessage = () => listeners.forEach((listener) => listener());
